export function emailValidator(
  value: string,
  allowSenderName?: boolean,
  usTariff?: boolean
) {
  if (value === "") return true;
  if (typeof value === "string") value = value.trim();
  if (value === "") return true;

  if (allowSenderName !== undefined && allowSenderName === true) {
    //Determine if a email is in the format "NAME <email@example.org>" (without quotes)

    const regex2 = /(?:"?([^"]*)"?\s)?(?:<?(.+@[^>]+)>)/;
    let m;

    if ((m = regex2.exec(value)) !== null) {
      // The result can be accessed through the `m`-variable.
      m.forEach((match, groupIndex) => {
        if (groupIndex == 2) value = match;
      });
    }
  }
  if (usTariff) {
    let regexUS = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@§°"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^\-])(((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|((([a-zA-Z\-0-9])([^\-\.]*)+\.)))+[a-zA-Z]{2,}){1,})$/
    );
    regexUS = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@§°"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(((((([a-zA-Z0-9])([^\.]*)+([^\-])\.)))+[a-zA-Z]{2,}){1,})$/
    );
    return regexUS.test(value);
  }

  const regex = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  return regex.test(value);
}

export function onlyLetterValidator(value: string) {
  if (value === "") return true;

  const regex = /^[a-zA-Z\s]*$/;

  return regex.test(value);
}

export function multiEmailValidator(value: string) {
  if (value === "") return true;

  //I need to split emails
  const emails = value.split(";");
  for (const email of emails) {
    if (!emailValidator(email)) return false;
  }

  return true;
}
